// extracted by mini-css-extract-plugin
export var container = "_m9-0";
export var dotAnimation = "_m9-2";
export var dotsLoading = "_m9-1";